import { useState } from 'react';

export const usePaymentSheet = () => {
  const [isProcessing] = useState(false);

  const launchPaymentSheet = async (_clientSecret: string) => {
    // Stub for web - Payment Sheet not available
    return {
      isSuccess: false,
      error: 'Payment Sheet not available',
      cancelled: false,
    };
  };

  const resetPaymentSheetCustomer = () => {};

  return {
    launchPaymentSheet,
    resetPaymentSheetCustomer,
    isProcessing,
  };
};
